import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
export function ProgramsCTABand() {
  return <section className="relative py-24 overflow-hidden bg-ink" data-id="element-2855">
      {/* Abstract diagonal background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-charcoal transform skew-x-12 translate-x-20 opacity-50 pointer-events-none" data-id="element-2856" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-2857">
        <h2 className="text-4xl md:text-5xl text-white mb-6" data-id="element-2858">
          Not Sure Which Class or Program is Right?
        </h2>
        <p className="text-xl text-gray-warm mb-10 max-w-2xl mx-auto" data-id="element-2859">
          Start with a trial class and Storm's coaches will help you find the
          best class or program based on your age, experience, and goals.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-2860">
          <Link to="/SignMeUp" className="btn-primary w-full sm:w-auto" data-id="element-2861">
            Claim Your Free Week
          </Link>
          <a href="tel:517-220-0621" className="btn-outline border-gray-warm text-white hover:bg-white hover:text-ink w-full sm:w-auto gap-2" data-id="element-2862">
            <Phone className="w-5 h-5" data-id="element-2863" />
            Call 517-220-0621
          </a>
        </div>
      </div>
    </section>;
}